export default __webpack_public_path__ + "static/media/news10.c75e09ff.jpg";